export enum DashboardAction {
  RESEND_ACTION = 'resend-confirm'
}
